<template>
  <Section id="proof" tone="muted" pad-y="md" :aria-labelledby="'proof-heading'">
    <Container>
      <div class="mb-8 flex flex-col items-center gap-2">
        <h2 id="proof-heading" class="text-xl font-bold text-ink-strong text-center md:text-2xl">
          {{ t('sections.proof.title') }}
        </h2>
        <p class="max-w-2xl text-sm text-ink-muted md:text-base">
          {{ t('sections.proof.subtitle') }}
        </p>
      </div>
      <LogoCloud :logos="TRUST_LOGOS" :caption="t('sections.trust.logosLabel')" />
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import LogoCloud from '@/components/domain/LogoCloud.vue';
import { TRUST_LOGOS } from '@/content/home-data';

const { t } = useI18n();
</script>
